type Uploaded = File | Blob | string | null | undefined;

export const parsePageNumbers = (pageNumbers: string): number[] => {
  if (!pageNumbers) return [];
  const pages = new Set<number>();
  const ranges = pageNumbers.split(",");

  ranges.forEach((raw) => {
    const range = raw.trim();
    if (!range) return;

    if (range.includes("-")) {
      const [startStr, endStr] = range.split("-");
      const start = parseInt(startStr.trim(), 10);
      const end = parseInt(endStr.trim(), 10);
      if (!isNaN(start) && !isNaN(end)) {
        const [lo, hi] = start <= end ? [start, end] : [end, start];
        for (let i = lo; i <= hi; i++) pages.add(i);
      }
    } else {
      const page = parseInt(range, 10);
      if (!isNaN(page)) pages.add(page);
    }
  });

  return Array.from(pages);
};

export const validatePageNumbersSyntax = (value: string): boolean => {
  if (!value.trim()) return true;
  const pattern = /^\s*(\d+\s*(?:-\s*\d+)?)(\s*,\s*\d+\s*(?:-\s*\d+)?)*\s*$/;
  return pattern.test(value);
};

export const getFileKind = (file: Uploaded): "pdf" | "image" | "unknown" => {
  if (!file) return "unknown";
  if (typeof file === "string") {
    const lower = file.toLowerCase();
    if (/\.(pdf)(\?|#|$)/.test(lower)) return "pdf";
    if (/\.(png|jpe?g|gif|webp|bmp|tiff?)(\?|#|$)/.test(lower)) return "image";
    return "unknown";
  }
  const type = (file as File | Blob).type || "";
  if (type.includes("pdf")) return "pdf";
  if (type.startsWith("image/")) return "image";
  return "unknown";
};

export const getImageSrc = (file: Uploaded): string | null => {
  if (!file) return null;
  if (typeof file === "string") return file;
  try {
    return URL.createObjectURL(file);
  } catch {
    return null;
  }
};

export type { Uploaded };
